import React, { useEffect, useState } from "react";
import PaginatedTable from "../common/PaginatedTable";
import DTIPages from "../common/DTIPages";
import DtiToolbar from "../common/DtiToolbar";
import DtiKpiGrid from "../common/DtiKpiGrid";
import DtiSectionHeading from "../common/DtiSectionHeading";
import DtiOverviewSkeleton from "../common/DtiSkeleton";
import {
  getJobLMSInfo,
  getLMSInfo,
  createJobLMSInfo,
} from "../api/api";

const KPI_HEADERS = [
  { id: "lmsSystemName", text: "Tên hệ thống LMS" },
  { id: "totalLecture", text: "Số bài giảng giáo viên đã tạo" },
  { id: "totalTest", text: "Số bài kiểm tra giáo viên đã tạo" },
  { id: "totalOnlineClass", text: "Số lớp học trực tuyến đã tạo" },
  { id: "totalQuestionBank", text: "Số ngân hàng câu hỏi đã tạo" },
  { id: "totalQuestions", text: "Số câu hỏi đã được tạo" },
  { id: "totalActiveLearner", text: "Số học sinh phát sinh hoạt động học tập" },
];

export default function LMSInfo({ iframe = false }) {
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    let intervalId;
    const fetchData = async () => {
      setIsFetching(true);
      try {
        setData(await getLMSInfo());

        const job = await getJobLMSInfo();
        if (["starting", "pending"].includes(job?.workflowState)) {
          setIsLoading(true);
          intervalId = setInterval(async () => {
            const jobStatus = await getJobLMSInfo();
            if (jobStatus?.workflowState === "done") {
              setIsLoading(false);
              clearInterval(intervalId);
              setIsFetching(true);
              try {
                setData(await getLMSInfo());
              } finally {
                setIsFetching(false);
              }
            }
          }, 1000);
        }
      } finally {
        setIsFetching(false);
      }
    };
    fetchData();
    return () => clearInterval(intervalId);
  }, []);

  const handleJob = async () => {
    if (isLoading) return;
    setIsLoading(true);
    await createJobLMSInfo();
    const intervalId = setInterval(async () => {
      const job = await getJobLMSInfo();
      if (job?.workflowState === "done") {
        setIsLoading(false);
        clearInterval(intervalId);
        setIsFetching(true);
        try {
          setData(await getLMSInfo());
        } finally {
          setIsFetching(false);
        }
      }
    }, 1000);
  };

  const showSkeleton = isFetching || isLoading;

  return (
    <>
      {iframe ? (
        <></>
      ) : (
        <>
          {showSkeleton ? (
            <DtiOverviewSkeleton kpiCount={7} />
          ) : (
            <>
          <DtiToolbar isLoading={isLoading} onRefresh={handleJob} />

          <DTIPages
            secondPage={
              <>
                <DtiSectionHeading>6.1.1 Tên hệ thống LMS</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>{data?.lmsSystemName}</li>
                <DtiSectionHeading>6.1.2 Chi tiết thống kê số bài giảng giáo viên đã tạo</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Dạng bài tập: {data?.dataLecture?.totalAssignment}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataAssignment}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng trang: {data?.dataLecture?.totalWiki}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataWiki}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng đề kiểm tra: {data?.dataLecture?.totalQuiz}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataQuiz}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng tập tin: {data?.dataLecture?.totalAttachment}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "filename",
                        text: "Tên tệp",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataAttachment}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng thảo luận: {data?.dataLecture?.totalDiscussion}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataDiscussion}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng URL bên ngoài: {data?.dataLecture?.totalExternalUrl}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "url",
                        text: "Đường dẫn được nhúng",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataExternalUrl}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng công cụ bên ngoài: {data?.dataLecture?.totalExternalTool}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "url",
                        text: "Đường dẫn được nhúng",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataExternalTool}
                  perPage={10}
                />
                <DtiSectionHeading>6.1.3 Chi tiết thống kê số bài bài kiểm tra đã tạo</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Dạng đề kiểm tra: {data?.dataTest?.totalQuiz}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataTest?.dataQuiz}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng bài tập có lấy điểm: {data?.dataTest?.totalAssignment}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataTest?.dataAssignment}
                  perPage={10}
                />
                <DtiSectionHeading>6.1.4 Chi tiết thống kê số lớp học trực tuyến đã tạo</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Số lớp học trực tuyến đã tạo: {data?.totalOnlineClass}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tên lớp học",
                        width: "16.666%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "16.666%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "16.666%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "16.666%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "16.666%",
                      },
                      {
                        id: "conference_type",
                        text: "Thuộc loại",
                        width: "16.666%",
                      },
                    ]
                  }
                  rows={data?.dataOnlineClass}
                  perPage={10}
                />
                <DtiSectionHeading>6.1.5 Chi tiết thống kê số ngân hàng câu hỏi đã tạo</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Số ngân hàng câu hỏi đã tạo: {data?.totalQuestionBank}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tên lớp học",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataQuestionBank}
                  perPage={10}
                />
                <DtiSectionHeading>6.1.6 Chi tiết thống kê số câu hỏi đã được tạo</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Số học sinh phát sinh hoạt động học tập: {data?.totalQuestions}
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "33.333%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "33.333%",
                      },
                      {
                        id: "count",
                        text: "Số câu hỏi được tạo trong khóa học",
                        width: "33.333%",
                      },
                    ]
                  }
                  rows={data?.dataQuestions}
                  perPage={10}
                />
                <DtiSectionHeading>6.1.7 Chi tiết thống kê số học sinh phát sinh hoạt động học tập</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Số học sinh phát sinh hoạt động học tập: {data?.totalActiveLearner}
                </li>
              </>
            }
            firstPage={
              <DtiKpiGrid
                items={KPI_HEADERS.map(({ id, text }) => ({
                  id,
                  label: text,
                  value: data?.[id],
                }))}
              />
            }
          />
            </>
          )}
        </>
      )}
    </>
  );
}
